import React from "react";
import { Bot, Paperclip, Plus } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import { menuRow } from "@/shared/components/menuStyles";

/** The composer's +: add files, or start a new agent with Builder (`newAgentHint` says where
    it goes). Dropping or pasting a file still attaches it with no menu. */
export default function PlusMenu({ onAddFiles, onNewAgent, newAgentHint }: {
  onAddFiles: () => void;
  onNewAgent: () => void;
  newAgentHint: string;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          title="Add files or a new agent"
          aria-label="Add files or a new agent"
          className="press w-7 h-7 shrink-0 rounded-[8px] hover:bg-[var(--accent-hover)] data-[state=open]:bg-[var(--accent-active)] flex items-center justify-center text-[var(--text-secondary)] hover:text-[var(--text-primary)] data-[state=open]:text-[var(--text-primary)]"
        >
          <Plus className="w-4 h-4" strokeWidth={1.75} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" align="start" sideOffset={8} className="w-[236px] p-1 rounded-[12px] bg-[var(--surface)] border border-[var(--hairline-strong)] shadow-menu">
        <DropdownMenuItem className={menuRow} onSelect={onAddFiles}>
          <Paperclip className="w-4 h-4 text-[var(--text-secondary)]" strokeWidth={1.75} />
          <span>Add files</span>
          <span className="ml-auto pl-3 text-[11.5px] text-[var(--text-tertiary)]">or drop them in</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator className="-mx-1 my-1 h-px bg-[var(--hairline)]" />
        <DropdownMenuItem className={menuRow} onSelect={onNewAgent}>
          <Bot className="w-4 h-4 text-[var(--text-secondary)]" strokeWidth={1.75} />
          <span>New agent</span>
          <span className="ml-auto pl-3 text-[11.5px] text-[var(--text-tertiary)]">{newAgentHint}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
